document.querySelector('#video').addEventListener('click', e => {
    document.querySelector('#video div').classList.add('d-none')
})
